export const nivelEscolaridade = [
    "Estou no 1º ano do Ensino Médio", 
    "Estou no 2º ano do Ensino Médio", 
    "Estou no 3º ano do Ensino Médio", 
    "Já concluí o Ensino Médio", 
    "Estou fazendo curso técnico/profissionalizante",
    "Já comecei outra graduação",
    "Outro"
];

export const fezEnem = [
    "Nunca fiz e ainda não vou fazer este ano",
    "Vou fazer como treineiro pela primeira vez",
    "Já fiz como treineiro",
    "Vou fazer valendo pela primeira vez",
    "Já fiz o Enem 1 vez valendo",
    "Já fiz o Enem 2 vezes ou mais",
    "Fiz o Enem, mas não usei minha nota",
];

export const acompanhamentoUniversidade = [
    "Sim",
    "Não",
];
